import { render, staticRenderFns } from "./PanelTitle.vue?vue&type=template&id=27cc3a3e&scoped=true&"
import script from "./PanelTitle.vue?vue&type=script&lang=js&"
export * from "./PanelTitle.vue?vue&type=script&lang=js&"
import style0 from "./PanelTitle.vue?vue&type=style&index=0&id=27cc3a3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cc3a3e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDivider,VIcon,VSpacer})
